ixModuleRouting("impactx.ghostloginapproval", {
    "/ghostloginapproval/:id": {
        template: "<ixa-ghost-login-approval></ixa-ghost-login-approval>",
        process: "GhostApproval"
    },
});
